import T from '../../../../common/components/T';
import { svgSprite } from '../../../../hybrid/wrappers';
import css from './Branch.module.scss';

export default function Branch({ val }) {
    if (!val || +val === 0 || typeof val !== 'number') return '-';
    return (
        <div className={css.wrapper}>
            <div className={css.icon}>
                {svgSprite(+val === 1 ? 'structure-left-new' : 'structure-right-new', { className: css.svg })}
            </div>
            <p className={css.name}>
                {+val === 1 ? (
                    <T textName='left_feminine' defaultStr='Левая' page='all' />
                ) : (
                    <T textName='right_feminine' defaultStr='Правая' page='all' />
                )}
            </p>
        </div>
    );
}
